(function () {
  'use strict';

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function money(n) {
    if (n == null || Number.isNaN(Number(n))) return 'Request Quote';
    return '$' + Number(n).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function tierClass(tier) {
    return String(tier || 'good').toLowerCase();
  }

  function renderEntry(entry) {
    var items = (entry.items || []).slice();
    items.sort(function (a, b) {
      if (a.isCurrent) return -1;
      if (b.isCurrent) return 1;
      return 0;
    });

    var rows = entry.rows || [];
    var html = '<div class="tcb-pdp-equipment-compare__panel">';
    html += '<p class="tcb-pdp-equipment-compare__lead">' + esc(entry.summary || entry.label) + '</p>';
    html += '<div class="tcb-pdp-equipment-compare__scroll"><table class="tcb-pdp-equipment-compare__table"><thead><tr>';
    html += '<th scope="col">Specification</th>';
    items.forEach(function (item) {
      html += '<th scope="col">';
      if (item.tier) html += '<span class="tcb-ec-tier tcb-ec-tier--' + tierClass(item.tier) + '">' + esc(item.tier) + '</span> ';
      html += '<a href="' + esc(item.url) + '">' + esc(item.title) + '</a>';
      if (item.isCurrent) html += '<span class="tcb-pdp-compare-fallback__badge">This item</span>';
      html += '</th>';
    });
    html += '</tr></thead><tbody>';

    rows.forEach(function (row) {
      html += '<tr><th scope="row">' + esc(row.label) + '</th>';
      items.forEach(function (item) {
        var val = (entry.values && entry.values[row.key] && entry.values[row.key][item.handle]) || '—';
        html += '<td' + (item.isCurrent ? ' class="is-current"' : '') + '>' + esc(val) + '</td>';
      });
      html += '</tr>';
    });

    html += '</tbody></table></div>';
    html += '<div class="tcb-pdp-equipment-compare__actions">';
    html += '<a class="tcb-rh-btn tcb-rh-btn--blue" href="' + esc(entry.url) + '">View full comparison</a>';
    html += '<a class="tcb-rh-btn tcb-rh-btn--outline" href="/pages/equipment-comparison">Browse all comparisons</a>';
    html += '</div></div>';
    return html;
  }

  function init() {
    var root = document.querySelector('[data-tcb-pdp-equipment-compare]');
    if (!root || root.getAttribute('data-bound') === '1') return;
    var mount = root.querySelector('[data-tcb-pdp-equipment-compare-mount]');
    var handle = root.getAttribute('data-product-handle');
    var url = root.getAttribute('data-compare-url');
    if (!mount || !handle || !url) return;

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var entry = data.byHandle && data.byHandle[handle];
        if (!entry || !(entry.items || []).length) return;
        root.setAttribute('data-bound', '1');
        mount.innerHTML = renderEntry(entry);
      })
      .catch(function () { /* keep liquid fallback */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
